// extracted by mini-css-extract-plugin
export default {"wrapperTable":"Locations_wrapperTable__s-1b3","contentClassName":"Locations_contentClassName__ETv7c","tabItem":"Locations_tabItem__kEw0h"};